import { Injectable } from '@angular/core';
import { Mockable } from '../mocks/mockable.decorator';
import { UrlUtils } from '../common/utils/url-utils';
import { Observable } from 'rxjs';
import { EmailSubscription } from '@deckplan.io/common';
import { HttpClient } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
@Mockable
export class EmailSubscriptionService {

    private readonly backendUrl = UrlUtils.constructBackendUrl('moderation/email-subscription');

    constructor(private readonly http: HttpClient) {}

    public getAll(): Observable<EmailSubscription[]> {
        return this.http.get<EmailSubscription[]>(`${this.backendUrl}`);
    }
}
